import React from 'react';
import { Button } from 'src/components-dummy/Button';
import { ConfirmationDialog } from 'src/components-dummy/ConfirmationDialog';
import { ButtonsContainer } from 'src/components-dummy/ConfirmationDialog/ConfirmationDialog.style';

interface DeleteSynonymConfirmationDialogProps {
  onCloseDeleteDialog: () => void;
  onDeleteConfirm: () => void;
}

export function DeleteSynonymConfirmationDialog({
  onCloseDeleteDialog,
  onDeleteConfirm,
}: DeleteSynonymConfirmationDialogProps): JSX.Element {
  return (
    <ConfirmationDialog onCancel={onCloseDeleteDialog}>
      <ConfirmationDialog.Header>
        <ConfirmationDialog.Title>Delete Synonym</ConfirmationDialog.Title>
      </ConfirmationDialog.Header>
      <ConfirmationDialog.Content>
        {`Are you sure you want to remove this synonym?`}
      </ConfirmationDialog.Content>
      <ConfirmationDialog.Footer>
        <ButtonsContainer>
          <Button variant='destructive' onClick={onDeleteConfirm}>
            Delete
          </Button>
          <Button variant='tertiary' onClick={onCloseDeleteDialog}>
            Cancel
          </Button>
        </ButtonsContainer>
      </ConfirmationDialog.Footer>
    </ConfirmationDialog>
  );
}
